import React, { useEffect, useState } from 'react';
import './Payment.css';
import { useNavigate } from 'react-router-dom';
import { getSessionStorage, setSessionStorage } from '../../utils/helper';
import Button from '../../components/button/Button';

interface MobileBank {
  code: string;
  name: string;
  shortName: string;
  color: string;
  logo?: string;
}

const MOBILE_BANKS: MobileBank[] = [
  { code: 'kbank', name: 'กสิกรไทย', shortName: 'KBank', color: '#1DB954', logo: '/assets/images/KBANK_LOGO.png' },
  { code: 'scb',   name: 'ไทยพาณิชย์', shortName: 'SCB',  color: '#4E2A84', logo: '/assets/images/SCB_LOGO.png' },
  { code: 'bay',   name: 'กรุงศรี',    shortName: 'BAY',  color: '#E8B42F', logo: '/assets/images/BAY_LOGO.png' },
  { code: 'bbl',   name: 'กรุงเทพ',    shortName: 'BBL',  color: '#1F3E7B', logo: '/assets/images/BBL_LOGO.png' },
  { code: 'ktb',   name: 'กรุงไทย',    shortName: 'KTB',  color: '#009999', logo: '/assets/images/KTB_LOGO.png' },
];

const Payment: React.FC = () => {
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState<string>('qr-promptpay');
  const [selectedBank, setSelectedBank] = useState<string>('');

  useEffect(() => {
    const raw = getSessionStorage('i')
    if (!raw) {
      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const paymentMethods = [
    {
      id: 'qr-promptpay',
      icon: '/assets/icons/icon-qr-promptpay.svg',
      name: 'QR พร้อมเพย์',
      desc: 'สแกน QR Code เพื่อชำระเงินผ่าน PromptPay',
    },
    {
      id: 'mobile-banking',
      icon: '/assets/icons/icon-credit-orange.svg',
      name: 'Mobile Banking',
      desc: 'ชำระเงินผ่านแอปธนาคารของคุณ',
    },
    {
      id: 'credit-debit-card',
      icon: '/assets/icons/icon-master-card.svg',
      name: 'บัตรเครดิต / บัตรเดบิต',
      desc: 'ชำระเงินด้วยบัตร Visa, Mastercard, JCB',
    },
  ];

  const handleProceed = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setSessionStorage('pm', selectedMethod as any);
    if (selectedMethod === 'mobile-banking') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setSessionStorage('pb', selectedBank as any);
    }
    navigate(`/payment-detail/${getSessionStorage('i')}`);
  };

  const isMobileBankingReady = selectedMethod !== 'mobile-banking' || selectedBank !== '';

  return (
    <section className="payment-wrapper">
      <div className="payment-container lg:container lg:mx-auto">

        {/* Header */}
        <div className="payment-header">
          <h2 className="payment-title">ชำระเงิน</h2>
          <p className="payment-subtitle">เลือกช่องทางการชำระเงิน</p>
        </div>

        {/* Payment methods */}
        <div className="payment-section">
          <p className="payment-section-label">วิธีการชำระเงิน</p>

          <div className="payment-method-list">
            {paymentMethods.map((method) => (
              <div key={method.id} className="payment-method-group">
                <button
                  type="button"
                  className={`payment-method-card ${selectedMethod === method.id ? 'selected' : ''}`}
                  onClick={() => setSelectedMethod(method.id)}
                >
                  <div className="method-icon-wrap">
                    <img src={method.icon} alt={method.name} className="method-icon" />
                  </div>
                  <div className="method-info">
                    <p className="method-name">{method.name}</p>
                    <p className="method-desc">{method.desc}</p>
                  </div>
                  <div className={`method-radio ${selectedMethod === method.id ? 'checked' : ''}`}>
                    {selectedMethod === method.id && (
                      <span className="radio-dot" />
                    )}
                  </div>
                </button>

                {/* Bank selection panel */}
                {method.id === 'mobile-banking' && selectedMethod === 'mobile-banking' && (
                  <div className="bank-select-panel">
                    <p className="bank-select-label">เลือกธนาคาร</p>
                    <div className="bank-grid">
                      {MOBILE_BANKS.map((bank) => (
                        <button
                          key={bank.code}
                          type="button"
                          className={`bank-item ${selectedBank === bank.code ? 'selected' : ''}`}
                          onClick={() => setSelectedBank(bank.code)}
                        >
                          <div className="bank-logo-wrap" style={{ background: bank.logo ? '#f9f9f9' : bank.color }}>
                            {bank.logo
                              ? <img src={bank.logo} alt={bank.name} className="bank-logo-img" />
                              : <span className="bank-logo-initial">{bank.shortName}</span>
                            }
                          </div>
                          <span className="bank-name">{bank.name}</span>
                          {selectedBank === bank.code && (
                            <span className="bank-check">✓</span>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Security badge */}
        <div className="payment-security">
          <img src="/assets/icons/icon-check.svg" alt="secure" className="security-icon" />
          <span>การชำระเงินปลอดภัย ข้อมูลของคุณถูกเข้ารหัส</span>
        </div>

        {/* CTA */}
        <div className="payment-cta">
          <Button
            variant="primary"
            fullWidth
            className="max-w-[28rem]"
            disabled={!selectedMethod || !isMobileBankingReady}
            onClick={handleProceed}
          >
            ดำเนินการชำระเงิน
          </Button>
        </div>

      </div>
    </section>
  )
}

export default Payment;
